import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const WorkEmailSettingsPage = lazy(() =>
  import('@/features/settings/notifications/NotificationsSettingsPage').then((m) => ({ default: m.NotificationsSettingsPage })),
);

export const Route = createFileRoute('/app/settings/notifications')({
  component: () => (
    <Suspense>
      <WorkEmailSettingsPage />
    </Suspense>
  ),
});
